var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBinariksLogoBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.88905,
    cy: 2.88905,
    r: 2.71396,
    stroke: "#2979FF",
    strokeWidth: 0.350173
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.932,
    cy: 2.88905,
    r: 2.71396,
    stroke: "#2979FF",
    strokeWidth: 0.350173
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9691,
    cy: 2.88905,
    r: 2.88905,
    fill: "#2979FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.88905,
    cy: 10.7553,
    r: 2.88905,
    fill: "#2979FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.932,
    cy: 10.7533,
    r: 2.88905,
    fill: "#2979FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9691,
    cy: 10.7533,
    r: 2.71396,
    stroke: "#2979FF",
    strokeWidth: 0.350173
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.88905,
    cy: 18.6176,
    r: 2.88905,
    fill: "#2979FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.932,
    cy: 18.6156,
    r: 2.88905,
    fill: "#2979FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9691,
    cy: 18.6156,
    r: 2.88905,
    fill: "#2979FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinariksLogoBlueIcon);
export default __webpack_public_path__ + "static/media/BinariksLogoBlueIcon.d7cd424cfcf1fe539ee11460e347a93b.svg";
export { ForwardRef as ReactComponent };